import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { RN_PROTOCOL_ITEMS } from './rnProtocolConstants';

const RnProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="RN"
            title="RN JOB DESCRIPTION & PROTOCOLS"
            items={RN_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default RnProtocol;
